import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom, take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/services/auth.service';
import { SubdomainService } from '../../../core/services/subdomain.service';
import { auth as AuthGen } from '@valvur/shared-grpc';
import { UserSharedService } from './user-shared.service';

@Injectable({ providedIn: 'root' })
export class TeacherService {
  #http = inject(HttpClient);
  #authService = inject(AuthService);
  #userShared = inject(UserSharedService);
  #subdomain = inject(SubdomainService);

  teacher = computed(() => this.#teacher.data());
  settings = computed(() => this.#userShared.settings());

  getBrowserLanguage(): string {
    return this.#userShared.getBrowserLanguage();
  }

  isLoading = computed(() => this.#teacher.isLoading());

  #teacher = injectQuery(() => ({
    queryKey: ['teacher'],
    retry: 1,
    queryFn: () =>
      lastValueFrom(
        this.#http
          .get<AuthGen.User>(`${environment.baseUrl}/user/teacher`)
          .pipe(take(1)),
      ),
    enabled:
      this.#authService.isAuthenticated() &&
      this.#subdomain.isSchoolSubdomain(),
  }));

  updateSettings = this.#userShared.updateSettings;
}
